import * as yup from 'yup';

import { FORM_FIELDS } from '@constants/form';

export const LEAVE = FORM_FIELDS.LEAVE;
export const BASIC_INFO = LEAVE.BASIC_INFO;
export const SUPPORTING_DOCUMENT = LEAVE.SUPPORTING_DOCUMENT;
export const SEND_FOR_APPROVAL = LEAVE.SEND_FOR_APPROVAL;
export const MODAL = LEAVE.MODAL;

export const applyLeaveFormValidation = yup.object().shape({
  [BASIC_INFO.FROM_DATE]: yup.string().required('Starting Date is required'),
  [BASIC_INFO.TO_DATE]: yup.string().required('End Date is required'),
  [BASIC_INFO.ADDRESS]: yup.string().required('Address is required'),
  [SUPPORTING_DOCUMENT]: yup
    .array()
    .of(
      yup.object().shape({
        name: yup.string(),
        mimeType: yup.string(),
        fileId: yup.string(),
        documentId: yup.string(),
        documentType: yup.string(),
      }),
    )
    .nullable(),
});

export type ApplyLeaveFormDataType = yup.InferType<
  typeof applyLeaveFormValidation
>;
